import ExcludedAccountGroup from "../../chartOfAccounts/ExcludedAccountGroup.js";
import Model from "../../Model.js";

/**
 * `ExclusionGroupSet` represents the exclusion data of a row. It can store,
 * add, remove and update the excluded account groups list.
 *
 * @param {abstractAccountGroupRowTemplate} rowTemplate - A row
 * template with excluded group ids.
 * @param {chartOfAccounts} chartOfAccounts - This is used to
 * build accounts tree and to find account aliases.
 */
export default class ExclusionGroupSet extends Model {
	constructor({ rowTemplate, chartOfAccounts }) {
		super(...arguments);

		this._rowTemplate = rowTemplate;

		this._rowAccountGroup = new ExcludedAccountGroup({
			id: rowTemplate.getAccountGroupId(),
			chartOfAccounts,
		});

		this._excludedGroups = rowTemplate
			.getExcludedGroupsIds()
			.map((id) => new ExcludedAccountGroup({ id, chartOfAccounts }));
	}

	getTopLevelAccountGroups() {
		const accountGroupChildren = this._rowAccountGroup.getChildren();

		const excludedGroupsNotInChartOfAccounts = this._excludedGroups.filter(
			(accountGroup) => !accountGroup.isInChartOfAccounts(),
		);

		return [...excludedGroupsNotInChartOfAccounts, ...accountGroupChildren];
	}

	isExcluded(accountGroup) {
		return this._excludedGroups.some((group) =>
			group.isEquivalentTo(accountGroup),
		);
	}

	getAccountGroupChildren(accountGroup) {
		return this.isExcluded(accountGroup) ? [] : accountGroup.getChildren();
	}

	setExclusionOfAccountGroup({ accountGroup, exclude }) {
		exclude
			? this._exclude(accountGroup)
			: this._stopExcluding(accountGroup);
	}

	updateExludedGroups() {
		this._rowTemplate.setExcludedGroups(
			this._excludedGroups.map((group) => group.getId()),
		);
	}

	_exclude(accountGroup) {
		if (this.isExcluded(accountGroup)) {
			return;
		}
		this._excludedGroups.push(accountGroup);
	}

	_stopExcluding(accountGroup) {
		this._excludedGroups = this._excludedGroups.filter(
			(group) => !group.isEquivalentTo(accountGroup),
		);
	}
}
